import { render, staticRenderFns } from "./YourProducts.vue?vue&type=template&id=2a77a118&scoped=true&"
import script from "./YourProducts.vue?vue&type=script&lang=js&"
export * from "./YourProducts.vue?vue&type=script&lang=js&"
import style0 from "./YourProducts.vue?vue&type=style&index=0&id=2a77a118&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a77a118",
  null
  
)

export default component.exports